import { Outlet } from '@tanstack/react-router';
import { Sidebar, SidebarContent } from './Sidebar';
import { TopChrome } from './TopChrome';
import { CommandPalette } from './CommandPalette';
import { MobileDrawer } from '@/components/MobileDrawer';
import { useUI } from '@/store/ui';

export function AppShell() {
  const mobileNavOpen = useUI((s) => s.mobileNavOpen);
  const closeMobileNav = useUI((s) => s.closeMobileNav);
  return (
    <div className="flex min-h-dvh bg-surface-soft">
      {/* Desktop sidebar — hidden on phones / narrow tablets, drawer takes over. */}
      <div className="hidden lg:flex">
        <Sidebar />
      </div>
      {/* Mobile off-canvas drawer — same nav, slides in from the left. */}
      <MobileDrawer
        open={mobileNavOpen}
        onOpenChange={(o) => (o ? null : closeMobileNav())}
        title="Navigation"
      >
        <SidebarContent collapsed={false} />
      </MobileDrawer>
      <main className="flex-1 min-w-0 flex flex-col">
        {/* Persistent top chrome (search / notifications / avatar) */}
        <TopChrome />
        <Outlet />
      </main>
      <CommandPalette />
    </div>
  );
}
